export default from './Activities';



// WEBPACK FOOTER //
// ./src/containers/Activities/index.js